/**
 * Names for the crawl's place kinds, and what a place becomes when it is added to Conductor (#253 step 3). Shared by
 * the Places tab, the map popup and the place panel.
 */

const KIND_LABEL: Record<string, string> = {
  crematorium: 'Crematorium',
  cemetery: 'Cemetery',
  funeral_home: 'Funeral home',
  mortuary: 'Mortuary',
  events_venue: 'Events venue',
  club: 'Club',
  rsl_club: 'RSL club',
  surf_club: 'Surf club',
  bowling_club: 'Bowling club',
  golf_course: 'Golf course',
  community_centre: 'Community centre',
  town_hall: 'Town hall',
  place_of_worship: 'Place of worship',
  pub: 'Pub',
  hotel: 'Hotel',
  restaurant: 'Restaurant',
  cafe: 'Café',
  park: 'Park',
  garden: 'Garden',
  botanic_garden: 'Botanic garden',
  beach: 'Beach',
  viewpoint: 'Lookout',
  picnic_site: 'Picnic area',
};

/** "place_of_worship" → "Place of worship", for any kind, known or not. */
export function kindLabel(kind: string | null | undefined): string {
  if (!kind) return 'Place';
  if (KIND_LABEL[kind]) return KIND_LABEL[kind];
  const s = kind.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export type BlockType = 'venue' | 'cremation' | 'burial' | 'mortuary';

/** The provider block a place of this kind becomes in Conductor. */
export function blockTypeFor(kind: string | null | undefined): BlockType {
  return kind === 'crematorium'
    ? 'cremation'
    : kind === 'cemetery'
      ? 'burial'
      : kind === 'mortuary' || kind === 'funeral_home'
        ? 'mortuary'
        : 'venue';
}

/** What to call each block type on an "Add to Conductor as …" button. */
export const BLOCK_LABEL: Record<BlockType, string> = {
  venue: 'Venue',
  cremation: 'Crematorium',
  burial: 'Cemetery',
  mortuary: 'Mortuary',
};

export const BLOCK_OPTIONS = (Object.keys(BLOCK_LABEL) as BlockType[]).map((value) => ({
  label: BLOCK_LABEL[value],
  value,
}));
